import React, { useState } from 'react';
import { Copy, Check } from 'lucide-react';
import Modal from '../../components/Modal';
import gafferArt from '../../assets/gaffer-pointing.png';
import { GAFFER_MANAGER_THANKS } from './managerPowers';
import ShareInvite from '../../components/ShareInvite';

/**
 * The panel both create wizards end on.
 *
 * It exists because the one-off game wizard used to end on nothing at all: it closed
 * itself and dropped the manager back on the list, having promised a game code on the
 * review step and then never shown one. The league wizard had the whole panel and the
 * game wizard had none of it, so this is the league's, generalised.
 *
 * The code box is optional - if the API ever answers without a code the panel still
 * renders and simply does not offer one, rather than showing an empty dashed box that
 * looks like a failure.
 *
 * The Gaffer's line is shown whether or not he was let into the game. He is the voice
 * of the place rather than a feature somebody switched on, and this is the one moment
 * on the platform where somebody has done work for other people's benefit with nothing
 * in it for themselves.
 */
function WizardSuccess({ title, icon: Icon, heading, blurb, code, codeLabel, footnote, onDone, shareKind, shareName }) {
  const [copied, setCopied] = useState(false);

  const copyCode = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <Modal title={title} onClose={onDone}>
      <div className="wizard-success">
        <Icon className="wizard-success-icon" size={48} />
        <h3>{heading}</h3>
        <p className="helper-text">{blurb}</p>

        {code && (
          <div className="league-code-display">
            <span className="league-code-value">{code}</span>
            <button type="button" className="copy-btn" onClick={copyCode} title={codeLabel}>
              {copied ? <Check size={18} /> : <Copy size={18} />}
            </button>
          </div>
        )}

        {/* Just created, so nobody is in yet and the link gets them straight in. */}
        {code && shareKind && (
          <ShareInvite kind={shareKind} name={shareName} code={code} straightIn />
        )}

        {footnote && <p className="helper-text">{footnote}</p>}

        {/* He stands beside what he is saying rather than above it, pointing into
            it — which is why this is the full figure and not the header's head
            crop, and why he is on the left. The slot sizes him with
            `object-fit: contain`, so the art's own proportions decide nothing. */}
        <figure className="gaffer-thanks">
          <img className="gaffer-thanks-art" src={gafferArt} alt="" aria-hidden="true" />
          <blockquote className="gaffer-thanks-bubble">
            <p>{GAFFER_MANAGER_THANKS}</p>
            <cite>The Gaffer</cite>
          </blockquote>
        </figure>

        <button type="button" className="primary-btn full-width" onClick={onDone}>
          Done
        </button>
      </div>
    </Modal>
  );
}

export default WizardSuccess;
